import type { WishlistDrawerContent } from '../../components/WishlistDrawer/WishlistDrawerContent';

let loading: Promise<typeof WishlistDrawerContent> | undefined;

/**
 * The wishlist drawer starts closed on every primary page, so its content is
 * imported on demand: prefetched when the visitor points at or focuses the nav
 * icon, and awaited before the drawer opens. A failed import is forgotten so
 * the next attempt retries it.
 */
export const loadWishlistDrawerContent = () => {
	loading ??= import('../../components/WishlistDrawer/WishlistDrawerContent')
		.then((module) => module.WishlistDrawerContent)
		.catch((error) => {
			loading = undefined;
			throw error;
		});

	return loading;
};
